/**
 * @generated SignedSource<<c5fd6de3270d3b1bed033df45691be9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type JobRunsListContainer_job$data = {
  readonly id: any;
  readonly jobRuns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly completedAt: any | null | undefined;
        readonly createdAt: any;
        readonly id: any;
        readonly startedAt: any | null | undefined;
        readonly status: GraphQLJobRunStatus;
        readonly updatedAt: any;
      };
    }>;
  };
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"DigestJobRunList_job">;
  readonly " $fragmentType": "JobRunsListContainer_job";
};
export type JobRunsListContainer_job$key = {
  readonly " $data"?: JobRunsListContainer_job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobRunsListContainer_job">;
};

import JobRunsListContainerRefetchQuery_graphql from './JobRunsListContainerRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": JobRunsListContainerRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "JobRunsListContainer_job",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DigestJobRunList_job"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 20
        },
        {
          "kind": "Literal",
          "name": "sortBy",
          "value": "started_at"
        },
        {
          "kind": "Literal",
          "name": "sortOrder",
          "value": "desc"
        }
      ],
      "concreteType": "GraphQLJobRunConnection",
      "kind": "LinkedField",
      "name": "jobRuns",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLJobRunEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLJobRun",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "completedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "jobRuns(limit:20,sortBy:\"started_at\",sortOrder:\"desc\")"
    }
  ],
  "type": "GraphQLJob",
  "abstractKey": null
};
})();

(node as any).hash = "c35251e65e3fddc78317d69a136f3043";

export default node;
